import { Drawer } from "@mui/material";

export default function SidePanel({
  open,
  setOpen,
  children,
  minWidth = false,
  encodingDetailWidth = false,
  isBackdropColorChange = true,
  onClose,
  isFullOpen,
}) {


  const closeSideBar = () => {
    setOpen(false);
  };

  const openSideBar = () => {
    setOpen(true);
  };


  return (
    <Drawer
    anchor="right"
    open={open}
    onClose={closeSideBar}
    sx={{
      width: isFullOpen
        ? "100%"
        : encodingDetailWidth
        ? { lg: "70%", xl: "70%", "2xl": "70%" }
        : minWidth
        ? { lg: "33.33%", xl: "33.33%", "2xl": "33.33%" }
        :  { lg: "75%", xl: "75%", "2xl": "83.33%" },
      "& .MuiDrawer-paper": {
        width: "inherit", // Ensures the drawer paper takes the width specified above
      },
    }}
  >
    {children}
  </Drawer>
  )

//   return (
//     <Transition show={open}>
//       <>
//         <Transition
//           enter="transition ease-in-out duration-150"
//           enterFrom="opacity-0"
//           enterTo="opacity-100"
//           leave="transition ease-in-out duration-150"
//           leaveFrom="opacity-100"
//           leaveTo="opacity-0"
//         >
//           <Backdrop
//             className={`fixed right-0 top-0 bottom-0  ${isBackdropColorChange ?"bg-gray-200" : "bg-gray-750 bg-opacity-5"}`}
//             onClick={()=>{
//               if(onClose){
//                 onClose();
//               }else{
//                 closeSideBar()
//               }
//             }}
//           />
//         </Transition>

//         <Transition
//           enter="transition ease-in-out duration-150"
//           enterFrom="opacity-100 transform translate-x-20"
//           enterTo="opacity-0"
//           leave="transition ease-in-out duration-150"
//           leaveFrom="opacity-100"
//           leaveTo="opacity-0 transform translate-x-20"
//         >
//           {/* <aside className="fixed right-0  top-0 bottom-0 inset-y-0 z-50 flex-shrink-0 xl:w-7/12 lg:w-7/12 md:w-full bg-white dark:bg-gray-900"> */}
//           <aside
//             style={{ zIndex: 999999 }}
//             className={`
//             fixed
//             right-0
//             top-0
//             bottom-0
//             inset-y-0
//             z-50
//             flex-shrink-0
//             bg-white
//             dark:bg-gray-900
//             sm:w-full
//             md:w-full
//             ${
//               isFullOpen ? "w-full" : encodingDetailWidth
//                 ? "lg:w-6/12 xl:w-6/12 2xl:w-6/12"
//                 : minWidth
//                 ? "lg:w-4/12 xl:w-4/12 2xl:w-4/12"
//                 : "lg:w-9/12 xl:w-9/12 2xl:w-10/12"
//             }
           
//             `}
//           >
//             {children}
//           </aside>
//         </Transition>
//       </>
//     </Transition>
//   );
}
